export default __webpack_public_path__ + "static/media/gl-2.2f3e157c.png";